module.exports = __webpack_public_path__ + "static/img/intro.trim.black.7be376f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro.trim.black.gif
// module id = 168
// module chunks = 2